function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.97012 16.4752H2.24251C1.82988 16.4752 1.49502 16.1403 1.49502 15.7278V2.27258C1.49502 1.85995 1.82992 1.52508 2.24251 1.52508H8.97012C9.38348 1.52508 9.71761 1.19096 9.71761 0.777592C9.71761 0.364225 9.38348 0.0300293 8.97012 0.0300293H2.24251C1.00614 0.0300293 0 1.0362 0 2.27258V15.7277C0 16.9641 1.00614 17.9702 2.24251 17.9702H8.97012C9.38348 17.9702 9.71761 17.6361 9.71761 17.2227C9.71761 16.8094 9.38348 16.4752 8.97012 16.4752Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7772 8.46772L13.2323 3.98266C12.9393 3.69262 12.4654 3.69638 12.1753 3.99015C11.8853 4.28391 11.8883 4.75708 12.1828 5.04712L15.4307 8.25242H6.72747C6.31411 8.25242 5.97998 8.58654 5.97998 8.99991C5.97998 9.41328 6.31411 9.74744 6.72747 9.74744H15.4307L12.1828 12.9527C11.8883 13.2428 11.8861 13.7159 12.1753 14.0097C12.3218 14.1577 12.5147 14.2325 12.7076 14.2325C12.8974 14.2325 13.0873 14.1607 13.2323 14.0172L17.7772 9.53211C17.9192 9.39159 17.9999 9.2002 17.9999 8.99988C17.9999 8.79963 17.9199 8.60901 17.7772 8.46772Z"
});

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4e2f5dad.svg";
export { ForwardRef as ReactComponent };